import { defineStore } from "pinia";

const userStore = defineStore("digiCounsel:user", {
    state: () => {
        return {
            accessToken: "" as string | null,
            refreshToken: "" as string | null,

            // 만료 시각(ms)
            expiresAt: 0,

            // 현재 시간(ms)
            now: Date.now(),

            userInfo: {} as any | null,
            roles: [] as any | null,

            timer: null as ReturnType<typeof setInterval> | null,
        };
    },

    actions: {
        isLogin() {
            return !!(this.accessToken && this.userInfo?.idx);
        },
        setInfo(userInfo: object | null) {
            this.userInfo = userInfo;
        },

        setRole(roles: any | null) {
            this.roles = roles;
        },

        setAccessToken(accessToken: string | null) {
            this.accessToken = accessToken;
        },

        setRefreshToken(refreshToken: string | null) {
            this.refreshToken = refreshToken;
        },

        /**
         * expiresIn : 서버가 준 남은 시간(초)
         */
        setExpiresIn(expiresIn: number | null) {
            if (!expiresIn) {
                this.expiresAt = 0;
                return;
            }

            // 현재시간 + expiresIn(초)
            this.expiresAt = Date.now() + expiresIn;
        },

        startTimer() {
            this.stopTimer();

            this.now = Date.now();

            this.timer = setInterval(() => {
                this.now = Date.now();
            }, 1000);
        },

        stopTimer() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },

        logout() {
            this.stopTimer();

            this.accessToken = "";
            this.refreshToken = "";
            this.userInfo = {};
            this.roles = [];

            this.expiresAt = 0;
            this.now = Date.now();
        },

        getRemainText() {
            const remain = Math.max(0, Math.floor((this.expiresAt - this.now) / 1000));

            const minutes = Math.floor(remain / 60);
            const seconds = remain % 60;

            if (minutes > 0) return `${minutes}분 ${seconds}초`;
            return `${seconds}초`;
        },
    },
});

export default userStore;
